import Cookies from 'js-cookie';
import { i18n } from '../../i18n';
import { isObject } from '../../util';

export const REFS = {
  INITIAL_STATE: {
    app: {
      language: i18n.language,
    },
    cookie: Cookies.get(),
    element: {},
    menu: {},
    property: {},
  },

  SET: 'REFS_SET',
};

export const RefsReducer = (draft, action) => {
  const { payload, type } = action;
  switch (type) {
    case REFS.SET:
      Object.entries(payload.refs.cookie || {}).forEach(([key, value]) =>
        Cookies.set(key, isObject(key) ? JSON.stringify(value) : value)
      );
      draft.app = {
        ...draft.app,
        ...(payload.refs.app || {}),
      };
      draft.cookie = {
        ...draft.cookie,
        ...(payload.refs.cookie || {}),
      };
      draft.element = {
        ...draft.element,
        ...(payload.refs.element || {}),
      };
      draft.menu = {
        ...draft.menu,
        ...(payload.refs.menu || {}),
      };
      draft.property = {
        ...draft.property,
        ...(payload.refs.property || {}),
      };
      break;

    default:
      return draft;
  }
};
